import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<h2 class=\"selected-name\" title={{this.title}}>\n  {{period-title this.value showDateRange=true fullDay=this.selectKit.options.fullDay}}\n</h2>\n\n{{d-icon this.caretIcon class=\"caret-icon\"}}", {
  moduleName: "select-kit/components/period-chooser/period-chooser-header.hbs"
});